import {css, html, LitElement, TemplateResult, unsafeCSS} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {classMap} from 'lit/directives/class-map.js';
import {headers} from '../../styles/headers';
import {when} from 'lit/directives/when.js';
import {mobileBreakPoint} from '../../styles/sizes';
import {styleMap} from "lit-html/directives/style-map.js";

@customElement('sp-field-container')
export class SpFieldContainer extends LitElement {
    static styles = [
        //language=CSS
        headers,
        css`
            :host {
                display: block;
                position: relative;
                padding-top: var(--sp-field-container-padding-top, 2px);
                padding-right: var(--sp-field-container-padding-right, var(--sp-default-padding));
                padding-bottom: var(--sp-field-container-padding-bottom, 2px);
                padding-left: var(--sp-field-container-padding-left, var(--sp-default-padding));
                box-sizing: border-box;
                margin-bottom: 7px;
                color: rgb(var(--sp-greydark));
            }

            :host([hidden]) {
                display: none;
            }
            
            .prepend {
                margin-top: 3px;
                margin-bottom: 5px;
            }

            .append {
                margin-top: 5px;
                margin-bottom: 3px;
            }

            .container {
                display: grid;
                width: 100%;
                grid-template-columns: auto max-content;
            }
            
            .icon {
                width: 1.5rem;
                height: 1.5rem;
                background-size: 100% auto;
                background-position: center center;
                background-repeat: no-repeat;
            }
            
            @media (max-width: ${ unsafeCSS(mobileBreakPoint) }) {
                :host {
                    padding-right: var(--sp-field-container-padding-right, var(--sp-default-padding-mobile));
                    padding-left: var(--sp-field-container-padding-left, var(--sp-default-padding-mobile));
                }
            }`
    ];

    @property({ type: String})
    icon: string;
    @property({ type: Function})
    iconClickCallback: Function;
    @property({ type: String})
    labelPosition: 'append' | 'prepend' = 'prepend';
    @property()
    label: string | TemplateResult;

    protected render() {
        return html`
                ${ when((this.label || this.icon) && this.labelPosition === 'prepend',() => this.getIntroTemplate() )}
                <slot></slot>
                ${ when((this.label || this.icon) && this.labelPosition === 'append',() => this.getIntroTemplate() )}`;
    }

    getIntroTemplate() {
        return html`
            <div class=${ classMap({
                container: true,
                append: this.labelPosition === 'append',
                prepend: this.labelPosition === 'prepend'
            }) }>
                <div style=${ styleMap({
                    'place-self': this.labelPosition === 'prepend' ? 'end start' : 'start start'
                }) }>${ this.label }</div>
                ${ when(this.icon, () => html`<div class="icon" part='icon' style=${ styleMap({
                    ...this.iconClickCallback && { cursor: 'pointer' },
                    'place-self': this.labelPosition === 'prepend' ? 'end start' : 'start start',
                    'background-image': `url(${ this.icon })`
                }) } @click=${ this.iconClickCallback }></div>`) }
            </div>`;
    }
}
